<template>
  <div class="row" data-id="mPower-form-builder">
    <div :class="[showSpy ? 'col-sm-8 col-lg-9' : 'col-12']">
      <div
        v-click-outside="clickOutside"
        data-spy="scroll"
        :class="[showSpy ? 'scrollSpy' : '']"
        data-target="#navbar-scroll"
      >
        <form
          ref="formRef"
          class="col-12 p-0"
          :data-id="name"
          :data-label="`mPower-${name}`"
          :autocomplete="autocomplete"
          @submit.prevent="submitForm"
        >
          <slot name="header"></slot>
          <div v-if="splitToTabs">
            <b-tabs v-model="activeTab">
              <b-tab v-for="(section, index) in sections" :key="index" :title="section.label" :id="`Tab-${section.label}`">
                <div v-for="(field, indexField) in section.fields" :key="indexField">
                  <form-template
                    :dataForm="dataForm || data"
                    :scheme="getRowScheme(field)"
                    :mutatedObject="mutatedObject"
                    @onChange="$emit('onChange', $event)"
                    :type="type"
                    :name="name"
                    :additionalData="additionalData"
                    :formVisibilityControl="formVisibilityControl"
                  >
                    <slot v-for="slot in passedSlots" :name="slot" :slot="slot" v-bind:data="mutatedObject" />
                  </form-template>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <div v-else-if="formStyle.rows">
            <div v-for="(row, index) in formStyle.rows" :key="index">
              <div :class="row.headingClass">{{ row.heading }}</div>
              <div :class="row.class">
                <div v-for="(column, indexColumn) in row.columns" :key="indexColumn" :class="column.class">
                  <div v-for="(field, indexField) in column.fields" :key="indexField">
                    <form-template
                      :dataForm="dataForm || data"
                      :scheme="getRowScheme(field)"
                      :mutatedObject="mutatedObject"
                      @onChange="$emit('onChange', $event)"
                      :type="type"
                      :name="name"
                      :additionalData="additionalData"
                      :formVisibilityControl="formVisibilityControl"
                    >
                      <slot v-for="slot in passedSlots" :name="slot" :slot="slot" v-bind:data="mutatedObject" />
                    </form-template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <form-template
            v-if="!isEmpty(getSchemeWithoutRows)"
            @onChange="$emit('onChange', $event)"
            :scheme="getSchemeWithoutRows"
            :mutatedObject="mutatedObject"
            :dataForm="dataForm || data"
            :component="component"
            :indexOfMutatedObject="indexOfMutatedObject"
            :type="type"
            :name="name"
            :additionalData="additionalData"
            :formVisibilityControl="formVisibilityControl"
          >
            <slot v-for="slot in passedSlots" :name="slot" :slot="slot" />
          </form-template>
          <slot v-bind:data="mutatedObject"></slot>
          <div
            :class="footerClass || 'form-inline bg-white py-3 border-top d-flex align-items-center'"
            v-if="showButtons"
            v-sticky="stickyConfig"
          >
            <div v-if="errorOnHTMLInput" class="mr-2">
              <i class="far fa-exclamation-triangle text-danger fa-1x" title="Invalid HTML code" v-b-tooltip.hover></i>
            </div>
            <button
              :data-id="[buttonType || type, name].filter((e) => e).join('_')"
              class="btn btn-primary my-2"
              :disabled="hasValidationErrors || formSubmitting || errorOnHTMLInput || loadingState"
              type="submit"
            >
              <i v-if="formSubmitting" class="far fa-spinner-third fa-spin"></i> {{ buttonType || type }}
              {{ name | capitalize }}
            </button>
            <slot name="buttons-middle" v-bind="{ disabled: formSubmitting || errorOnHTMLInput }"></slot>
            <button
              :data-id="'close'"
              v-if="showCloseButton"
              class="btn btn-link"
              :disabled="formSubmitting"
              type="button"
              @click="$emit('cancel')"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from '@/main';
import ClickOutside from 'vue-click-outside';

const sleep = (t = 1000) => new Promise((resolve) => setTimeout(resolve, t));
export default {
  name: 'formBuilder',
  inject: ['$validator'],
  data() {
    return {
      mutatedObject: {},
      errorOnHTMLInput: false,
      columnFields: [],
      pending: false,
      loaded: false,
      selectedTypes: [],
      formStyle: {},
      tempScheme: {},
      activeTab: 0,
      sections: [],
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'm/d/Y',
        altInput: true,
        dateFormat: 'm/d/Y' // locale for this instance only
      }
    };
  },
  directives: {
    ClickOutside
  },
  props: {
    buttonType: String,
    indexOfMutatedObject: Number,
    scheme: {
      type: Object,
      required: true,
      validator(value) {
        for (const field in value) {
          if (value[field].type === 'select') {
            if (!value[field].array && !value[field].relations) {
              console.error('You should perform array or relations in scheme object');
              return false;
            }
          }
        }
        return true;
      }
    },
    component: {
      type: Object
    },
    data: {
      type: Object,
      default: null
    },
    dataForm: {
      type: Object,
      default: null
    },
    name: {
      type: String
      // validator(value) {
      //   if (!value.length) {
      //     console.error('Invalid value for prop `name`. Length should be more than 0');
      //     return false;
      //   }
      //   return true;
      // }
    },
    mutated: {
      type: Object,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: false,
      default: 'Save'
    },
    submitName: {
      type: String,
      required: false
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'on'
    },
    showButtons: {
      type: Boolean,
      required: false,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true
    },
    customSubmittedName: {
      type: String,
      required: false,
      default: 'name'
    },
    emitCancel: {
      type: Boolean,
      required: false,
      default: true
    },
    formVisibilityControl: String,
    showSpy: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    },
    fixButtons: {
      type: Boolean,
      default: false
    },
    additionalData: Object,
    test: Object,
    save: [Function, Object],
    stickyConfig: {
      type: Object,
      default: () => ({
        zIndex: 49,
        stickyVal: 0,
        type: 'bottom'
      })
    },
    footerClass: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean
    },
    splitToTabs: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.type !== 'Edit') {
      this.mutatedObject = this.mutated ? this.mutated : this.mutatedObject;
    }
    if (this.data) {
      this.data = this.constructObject(this.data, this.scheme);
    }
    this.mutatedObject = this.constructObject(this.mutatedObject, this.scheme);
    this.mutatedObject = this.data ? this.data : this.mutatedObject;
    this.mutatedObject = this.addIds(this.mutatedObject);
    eventBus.$on(`submit${this[this.customSubmittedName]}Form`, this.runSubmitVerification);
    eventBus.$on(`validateForm`, this.onValidate);
    this.$emit('init', this.mutatedObject);
    if (this.name === 'Store' && this.stickyConfig) this.stickyConfig.zIndex = 1;
    this.loaded = true;

    if (this.splitToTabs) {
      this.sections = this.constructSections(this.scheme);
    }
  },
  computed: {
    hasValidationErrors() {
      const errors = this.$validator?.errors ?? this.errors;
      return errors && typeof errors.any === 'function' ? errors.any() : false;
    },
    formSubmitting() {
      return this.pending || this.submitting;
    },
    loadingState() {
      return this.loading;
    },
    getSchemeWithoutRows() {
      const tempScheme = Object.assign({}, this.scheme);
      if (typeof tempScheme.type === 'string') {
        delete tempScheme.type;
      }
      delete tempScheme.formStyle;
      for (const prop in tempScheme) {
        if (this.columnFields.includes(prop)) {
          delete tempScheme[prop];
        }
      }
      return tempScheme;
    },
    passedSlots() {
      const slotNames = Object.keys(this.$slots);
      const index = slotNames.findIndex((slot) => slot === 'default');
      if (index > -1) {
        slotNames.splice(index, 1);
      }
      return slotNames;
    }
  },
  destroyed() {
    eventBus.$off(`submit${this[this.customSubmittedName]}Form`);
    eventBus.$off(`validateForm`);
  },
  methods: {
    onValidate(error) {
      this.errorOnHTMLInput = error;
    },
    clickOutside() {
      this.$emit('onBlur', this.mutatedObject);
    },
    forbiddenFieldName(type) {
      return ['relations', 'helpOptions', 'default', 'display'].includes(type);
    },
    isEmpty(object) {
      return Object.values(object).every((x) => !x);
    },
    getRowScheme(field) {
      if (!this.columnFields.includes(field)) {
        this.columnFields.push(field);
      }
      const object = {};
      object[field] = this.scheme[field];
      return object;
    },
    addIds(object) {
      if (!object.keyId) {
        this.$set(object, 'keyId', Math.floor(Math.random() * 10000));
      }
      return object;
    },
    constructObject(mutatedObject, scheme) {
      for (const field in scheme) {
        if (!this.forbiddenFieldName(field)) {
          if (field === 'formStyle') {
            this.formStyle = Object.assign({}, scheme[field]);
          } else {
            this.$set(
              mutatedObject,
              field,
              mutatedObject[field]
                ? mutatedObject[field]
                : scheme[field].type === 'checkbox'
                ? scheme[field].default && !mutatedObject.hasOwnProperty([field])
                : scheme[field].type === 'array' || scheme[field].type === 'objectArray'
                ? []
                : scheme[field].type === 'object'
                ? this.constructObject({}, scheme[field])
                : scheme[field].type === 'objectSelect'
                ? {}
                : scheme[field].default || mutatedObject[field]
                ? mutatedObject[field]
                : ''
            );
          }
        }
      }
      if (!mutatedObject.type && typeof mutatedObject.type === 'string') {
        delete mutatedObject.type;
      }
      return mutatedObject;
    },
    constructSections(scheme) {
      const sectionsMap = {};
      let lastSectionLabel = '';

      for (const field in scheme) {
        const sectionLabel = scheme[field].sectionLabel || lastSectionLabel;

        if (!sectionsMap[sectionLabel]) {
          sectionsMap[sectionLabel] = {
            label: sectionLabel,
            fields: []
          };
        }

        sectionsMap[sectionLabel].fields.push(field);

        if (scheme[field].sectionLabel) {
          lastSectionLabel = scheme[field].sectionLabel;
        }
      }

      return Object.values(sectionsMap);
    },
    modifyObjectWithAddress() {
      return new Promise(async (resolve, reject) => {
        try {
          if (
            this.mutatedObject.hasOwnProperty('city') &&
            this.mutatedObject.hasOwnProperty('street1') &&
            this.mutatedObject.hasOwnProperty('zip') &&
            this.mutatedObject.hasOwnProperty('state')
          ) {
            resolve(this.setCoordinates(this.mutatedObject));
          } else resolve(this.mutatedObject);
        } catch (err) {
          reject(err);
        }
      });
    },
    async submitForm() {
      try {
        if (this.pending) return;
        this.pending = true;
        await this.$validator.validateAll();

        if (this.hasValidationErrors) {
          this.pending = false;
          return;
        }

        if (this.save) {
          await this.save(await this.modifyObjectWithAddress());
        } else {
          // console.log(`submit${this.submitName || this.name}`);
          const action = `submit${this.submitName || this.name || ''}`;
          console.log('submit form', action);
          this.$emit(action, await this.modifyObjectWithAddress());
          await sleep(1000);
        }

        if (this.emitCancel) {
          this.$emit('cancel');
        }
      } catch (e) {
        this.notifyError(e.message || e.data?.message || e || 'Bad error');
      } finally {
        this.pending = false;
      }
    },
    async runSubmitVerification() {
      if (this.$refs.formRef && !this.$refs.formRef.checkValidity()) {
        this.$emit(`unvalid${this.submitName || this.name}`);
        this.$refs.formRef.reportValidity();
        return;
      }
      this.$emit(`submit${this.submitName || this.name}`, {
        data: await this.modifyObjectWithAddress(),
        eventName: `submited${this[this.customSubmittedName]}`
      });
      this.$emit('cancel');
    }
  },
  components: {
    formTemplate: () => import('./Form')
  }
};
</script>
